import { Grid, FormControl, TextField, Box } from '@mui/material';
import { IReportField } from '../../types/reportField';

const DateRangeFilterField = ({ reportField, onChange, onChangeSecondValue }: { reportField: IReportField; onChange; onChangeSecondValue }) => (
  <Grid size={{ xs: 12 }}>
    <FormControl sx={{ mb: 3, width: '100%' }}>
      <Box sx={{ mb: 1 }}>
        <label>{reportField?.caption}:</label>
      </Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ pr: 2 }}>From:</Box>
            <TextField type="date" variant="outlined" onChange={onChange} defaultValue={reportField?.fieldValue} fullWidth />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ pr: 2 }}>To:</Box>
            <TextField type="date" variant="outlined" onChange={onChangeSecondValue} defaultValue={reportField?.fieldValue2} fullWidth />
          </Box>
        </Grid>
      </Grid>
    </FormControl>
  </Grid>
);

export default DateRangeFilterField;
